module.exports = __webpack_public_path__ + "img/111001.b1a514dc.png";